import { render, staticRenderFns } from "./Bundles.vue?vue&type=template&id=0049fc9b&scoped=true"
import script from "./Bundles.vue?vue&type=script&lang=js"
export * from "./Bundles.vue?vue&type=script&lang=js"
import style0 from "./Bundles.vue?vue&type=style&index=0&id=0049fc9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0049fc9b",
  null
  
)

export default component.exports